export namespace CommonModels {
  export enum AgencyStatusEnum {
    Subscription = 1,
    WaitingSignature = 2,
    Validated = 3,
    Archived = 4,
  }

  export enum HealthAvenantType {
    CHANGE_ADDRESS,
    CHANGE_NAME,
    CHANGE_WARRANTY,
    MODIFY_MAIN_BENEFICIARY,
    REPLACE_MAIN_BENEFICIARY,
    ADD_BENEFICIARY,
    CHANGE_BENEFICIARY,
    REMOVE_BENEFICIARY,
    CHANGE_SOCIALSYSTEM,
    CHANGE_PAYMENT,
    REDUCTION,
    SPLIT_CONTRACT,
  }

  export enum AccountKind {
    Broker = 1,
    Client = 2,
    BackOffice = 3,
  }

  export enum RenewalBehavior {
    Mantien = 1,
    Termination = 2,
  }

  export enum FaqCategory {
    Gestion = 1,
    Adp = 2,
    Iard = 3,
  }

  export enum ContactCategory {
    Animation = 1,
    Gestion,
    Prestations,
    It,
    PrestationsEcoPlus,
  }

  export enum ProductDocumentationCategory {
    All = 1,
    Auto,
    Acheel,
    Infinity,
    Fidelity,
    Rop,
    ProduitsSante,
    ADPSantePrevoyance,
  }

  export enum ScreenType {
    Doc = 1,
    Tutorial = 2,
    Demarchage = 3,
    News,
    Contact,
  }

  export enum AagContext {
    TunnelSante = 1,
    AA = 2,
  }

  export enum InsurerSlipType {
    Encaissement = 1,
    Commission = 2,
  }

  export enum CivilityEnum {
    Homme = 1,
    Femme = 2,
  }

  export enum CompanyTypeEnum {
    EI = 1,
    EURL = 2,
    SARL = 3,
    SA = 4,
    SASU = 5,
    SAS = 6,
    SNC = 7,
  }

  export enum AccountKindEnum {
    Broker = 1,
    Client,
    Backoffice,
  }

  export enum InsuranceTypeEnum {
    Auto = 1,
    Moto = 2,
    PanneMecanique = 3,
    Permis = 4,
    Habitation = 5,
    Sante = 6,
    Rop = 7,
  }

  export enum EmailContextEnum {
    Agency = 1,
    Policy = 2,
  }

  export interface MinMaxMetric {
    min: number;
    max: number;
  }

  export enum SlipRequestType {
    Standard = 1,
    Regularisation = 2,
    AvanceDeCom = 3,
  }

  export enum StatusEnum {
    Default = 1,
    PartiallyValid = 2,
    Invalid = 3,
    Valid = 4,
  }

  export enum TunnelSanteAppEnum {
    Broker = 1,
    Backoffice = 2,
    Client = 3,
  }

  // To be challenged
  export enum YesNoEnum {
    No = 0,
    Yes = 1,
  }

  export enum EmailsFrom {
    noreply = 1,
    GestionSante = 2,
    Courtier = 3,
  }

  export enum Insurers {
    Axa = 1,
    Generali = 2,
    SwissLife = 3,
    Miltis = 4,
  }

  export enum RdvReasonEnum {
    OffersAutos = 1,
    OffersHealthOrIJH = 2,
    FormationExtranetTool = 3,
    DigitalHelp = 4,
    SupportDDA = 5,
    Other = 6,
  }

  export enum RdvPeriodEnum {
    Morning = 1,
    Afternoon = 2,
  }
}
